import { React, useEffect, useState } from "react";
import MoreButton from "../HomePage/MoreButton";
import { cartAction } from "../../api/cart";
import { useAuth, useNotification } from "../../hooks";
import { Link, useNavigate } from "react-router-dom";
import { FaMoneyBill, FaShoppingBasket, FaShoppingCart, FaCartArrowDown,FaCheck  } from "react-icons/fa";

import { Badge, Col, Form, Row } from "react-bootstrap";
import {
    Avatar,
    Chip,
    CircularProgress,
    FormControl,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Rating,
    Box,
    TextField,
} from "@mui/material";
import ProductGallery from "./ProductGallery";
import { cropText, formatMoney } from "../../hooks/useCustomHelpingMethod";
import { ApiCall } from "../../api/HelpingMethod";
import Button from "@mui/material/Button";
import ProductNotifyMe from "./ProductNotifyMe";
import ProductReviewModal from "../BookingDetails/component/ProductReviewModal";
import DeliveryImage from "../asset/superfastdelivery.png"
import FreeExpertSupport from "../asset/expertsupport.png"
import SecurePayment from "../asset/securepayment.png"
import LoginModal from "../../../src/Context/LoginModal";
import { MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog } from "mdb-react-ui-kit";
import { BsXLg } from 'react-icons/bs';



export default function ProductInfoCard({ part, id, title, brand, img, inCart, model }) {
    const { showError, showSuccess } = useNotification()
    const [buttonText, setButtonText] = useState("Add to Cart")
    const [buttonTextBuy, setButtonTextBuy] = useState("Buy Now")
    const [buyNowLoading, setByNowLoading] = useState(false)
    const [isAvailable, setIsAvailable] = useState(false)

    const [cart, setCart] = useState(inCart)
    const { authInfo } = useAuth()
    const [colorChange, setColorChange] = useState(false)
    const { setShowLoginModel } = useNotification();
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnLoading2, setBtnLoading2] = useState(false)
    const [btnText, setBtnText] = useState('Check')
    const [data, setData] = useState('')
    const [colorVariants, setColorVariants] = useState(part?.variant_products || [])
    const [images, setImages] = useState(part?.url_images || [])
    const [showLoginModellogin, setShowLoginModellogin] = useState(false);

    
    const [compatibleLimitDefault] = useState(25)
    const [compatibleLimit, setCompatibleLimit] = useState(compatibleLimitDefault)
    //   console.log("Part" , part);
    useEffect(() => {
        setColorVariants(part?.variant_products || []);
        setImages(part?.url_images || []);
    }, [part])

    const navigate = useNavigate()
    
    const onClick = async () => {
        setButtonText("loading...");
        setBtnLoading(true);
        if (!authInfo.profile.id) {
            setButtonText("Add to Cart");
            setBtnLoading(false);
            setShowLoginModellogin(true); // Show modal
            // return; // exit early
        } else {
            const data = await cartAction({
                id: authInfo?.profile?.id,
                user_type: authInfo?.profile?.user_type,
                actionType: "add_to_cart",
                part_id: id
            })
            if (!data.data || data.data.error) {
                showError(data.data.message || "An error occurs");
                setColorChange(true);
                setButtonText("View Cart");
                setBtnLoading(false);

            } else {
                showSuccess(data.data.message)
                setCart("yes");
                setColorChange(true);
                setButtonText("Added to Cart");
                setBtnLoading(false);

            }
            window.location.reload();
        }
    };

    console.log(images)

    const [bodyData, setBodyData] = useState({
        "login_user_id": authInfo.profile.id,
        "login_user_type": authInfo.profile.user_type,
        "pincode": "",
        "limit": 10,
        "offset": 0
    })

    const handleChangePincode = (e) => {
        const { name, value } = e.target;
        setBodyData({ ...bodyData, [name]: value })
    }

    const getDeliveryAddress = async (e) => {
        e.preventDefault();
        setBtnLoading2(true);
        setBtnText(<>Check</>)

        const response = await ApiCall("dealer/delivery_pincode", bodyData)
        if (bodyData.pincode === '') {
            // showError('Please enter the pincode')
            setData(<b className={'text-danger '}>Please enter the pincode</b>)
        } else {
            if (response?.error === false) {
                let message = {
                    'cod': {}, 'delivery': {},
                };
                if (response?.data?.is_cod_available === 'yes') {
                    message.cod = {
                        error: false,
                        message: "COD is available.",
                    }
                } else {
                    message.cod = {
                        error: true,
                        message: "COD is not available.",
                    }
                }
                if (response?.data?.is_delivery_available === 'yes') {
                    message.delivery = {
                        error: false,
                        message: "Delivery is available at your location.",
                    }
                } else {
                    message.delivery = {
                        error: true,
                        message: "Delivery is not available at your location.",
                    }
                }

                // setData("<b>" + message + "</b>")
                setData(message);
                // showSuccess(response?.message)
            } else {

                setData({
                    cod: {
                        error: true,
                        message: "COD is not available.",
                    }, delivery: {
                        error: true,
                        message: "Delivery is not available at your location.",
                    }
                })
                // showError(response?.message)
            }
        }
        setBtnLoading2(false);
        setBtnText('Check')
    }

    const onNavigate = async () => {
        navigate("/cart");
    }

    const style = { color: "#ee610f", fontSize: "1.5em" }

    const part_title = part?.title || title || "";
    // const part_title_category = part?.title_category || "";
    const Compatiblity = "Compatible"
    const part_title_brand = part?.title_brand || brand;
    const part_title_model = part?.title_model || model;
    const part_priceMrp = part?.amount_mrp || 0;
    let part_priceUser = part?.amount_total || 0;

    // 
    const reviews = part?.reviews;

    if (authInfo.profile) {
        if (authInfo.profile.user_type && authInfo.profile.user_type === 'dealer') {
            part_priceUser = part?.amount_total_dealer || 0;
        } else {
            part_priceUser = part?.amount_total_customer || 0;
        }
    }
    const moneySymbol = part?.amount_currency_symbol || "₹";


    let discountPerUser = part?.rate_discount || 0;
    let discountAmountUser = part?.amount_discount || 0;
    if (authInfo.profile) {
        if (authInfo.profile.user_type && authInfo.profile.user_type === 'dealer') {
            discountAmountUser = part?.amount_discount_dealer || 0;
        } else {
            discountAmountUser = part?.amount_discount_customer || 0;
        }
    }

    const onClickBuyNow = async () => {

        setButtonTextBuy("loading...");
        setByNowLoading(true);
        if (!authInfo?.profile?.id) {
            setShowLoginModel(true);
            showError("Please login to buy this product");
            setButtonTextBuy("Buy Now");
            setByNowLoading(false);

            // navigate("/auth");
        } else {
            const data = await cartAction({
                id: authInfo?.profile?.id,
                user_type: authInfo?.profile?.user_type,
                actionType: "add_to_cart",
                part_id: id
            })
            setButtonTextBuy("Buy Now");
            setByNowLoading(false);

            if (!data.data || data.data.error) {
                showError(data.data.message || "An error occurs");
            } else {
                // showSuccess(data.data.message)
                // navigate("/cart?token_part=" + (part?.token));
                navigate("/cart-checkout?token_part=" + (part?.token));
            }
        }
    };


    // const partColor = [
    //     {
    //         id: 1,
    //         color: "#d11616",
    //         is_selected: true,
    //     }, {
    //         id: 2,
    //         color: "#6f4afb",
    //         is_selected: false
    //     }, {
    //         id: 3,
    //         color: "#6af1cd",
    //         is_selected: false
    //     }, {
    //         id: 4,
    //         color: "#9da905",
    //         is_selected: false
    //     }
    // ]

    useEffect(() => {
        if (part) {
            setIsAvailable(part?.status === 'active' && part?.availability === 'available');
        }
    }, [part]);


    let part_rating = part?.count_rating_overall && part?.count_rating_overall !== 0 ? part?.count_rating_overall : 3.5;

    console.log('part',part);
 console.log("token",part?.user_review?.token_review_for);
    return (
        <>          
        
        <div className="card shadow /*cartProduct*/">
            <div className="card-body {/*cart-product-card*/}">
                <Row className={'g-3'}>
                    <Col md={12} lg={6}>
                        <div className="{/*product-info-image*/}">
                            <div className="product-img-mobile">
                                <ProductGallery img={images} discount={discountPerUser} data={part} />
                            </div>

                            {/*<ProductGalleryLightBox images={img}/>*/}
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className="mx-4">
                            <h3 className="card-title my-2 product-info-heading ">
                                <b>{part_title || ""}</b>
                            </h3>
                            <div className="d-flex">
                                { }
                                <Rating readOnly name="simple-controlled"
                                    value={part_rating || 0}
                                    defaultValue={part_rating || 0}
                                    precision={0.5} />
                                    
                   
                     { part?.show_user_add_review === "yes" &&  (
                      <ProductReviewModal 
                      count_rating={part?.reviews?.count_rating}
                      token_ref={part?.token_part || part?.token}
                       ref_type="part"
                      reviewFor="order"
                    //  tokenReviewFor={part?.user_review?.token_review_for}
                     />
                        )}

                            </div>
                            <div className="d-flex mt-2">
                                {isAvailable ? <>
                                    <FaMoneyBill style={style} className={"mr-3"} />
                                    <span className="text-decoration-line-through mx-2  fw-bold">
                                        {moneySymbol || "Rs."}{formatMoney(part_priceMrp ?? 0)}
                                    </span>
                                    <p className="fw-bold fs-5 color-primary mr-3">
                                        {moneySymbol || "Rs."}{formatMoney(part_priceUser ?? 0)}
                                    </p>
                                </> : <h5 className={'m-2'}><Badge pill bg="danger">Out Of Stock</Badge></h5>}
                                {isAvailable && discountAmountUser && discountAmountUser > 0 ?
                                    <Chip size="small"
                                        label={"SAVE " + (moneySymbol || "Rs.") + " " + (formatMoney(discountAmountUser || 0))}
                                        color="success"
                                        className={'m-2'} /> : ""}
                            </div>
                            {/*<p className="card-text my-1">
                                <small className="fw-bold">Category:</small> <Chip size="small" className={'m-1'}
                                    variant="outlined" color="primary"
                                    label={part_title_category} />

                            </p>*/}
                            <div className="card-text my-1">
                                <small className="fw-bold">Compatible Brand:</small> <Chip size="small" className={'m-1'}
                                    variant="outlined" color="primary"
                                    label={part_title_brand} />

                            </div>
                    
                           {!part_title_model?<>
                            <div className="card-text my-1">
                                <small className="fw-bold">Compatible Model: </small><Chip size="small" className={'m-1'}
                                    variant="outlined" color="primary"
                                    label={part_title_model} />
                            </div>
                            </>:
                            part?.compatibility && <>
                                <div className="card-text my-1">
                                    <small className="fw-bold">Compatible
                                        Models: </small><span><small>
                                            {compatibleLimit && part?.compatibility?.length > compatibleLimitDefault ?
                                                <>{cropText(part?.compatibility, compatibleLimit)} <b
                                                    onClick={() => setCompatibleLimit(0)}
                                                    className={"pointer color-primary"}>more</b></> :
                                                <>{part?.compatibility} {part?.compatibility?.length > compatibleLimitDefault &&
                                                    <b onClick={() => setCompatibleLimit(compatibleLimitDefault)}
                                                        className={"pointer color-primary"}>less</b>}</>
                                            }
                                        </small></span>
                                </div>
                            </>}
                                        

                          

                            <div className={'mt-0 '}>
                                {part?.part_color && part?.part_color !== "" ? <>
                                    <Row> <Col className="mb-1 mt-0 d-flex">
                                        <small className="fw-bold me-2 my-2">Color : </small>
                                        {colorVariants && Array.isArray(colorVariants) && colorVariants?.length >= 0 ?
                                            colorVariants.map((partColor, index) => {
                                                let isSelect = partColor?.part_color === part?.part_color;
                                                let color = {
                                                    bgcolor: partColor?.part_color || '#fffff',
                                                    width: 20,
                                                    height: 20
                                                };
                                                return (
                                                    <Link key={index} to={"/product/" + partColor.slug}
                                                        className={'text-decoration-none text-dark'}>
                                                        <Avatar key={partColor.id} variant="rounded"
                                                            className={isSelect ? "mt-2 mx-1 selected-color" : "mt-2 mx-1 pointer not-selected-color"}
                                                            sx={color}>{" "}</Avatar>
                                                    </Link>
                                                )
                                            })
                                            :
                                            <>
                                                {part?.part_color && part?.part_color !== "" &&
                                                    <>
                                                        <small className="fw-bold me-2 mt-2">Color: </small>
                                                        <Avatar variant="rounded" className={"mt-2 mx-1 selected-color"}
                                                            sx={{
                                                                bgcolor: part?.part_color || '', width: 25,
                                                                height: 25
                                                            }}>{""}</Avatar>
                                                    </>
                                                }
                                            </>
                                        }
                                    </Col> </Row>
                                </> : <></>}

                                 <Row className="fw-bold my-2"><Col>Check COD Available</Col></Row>
                                <Row>
                                    <Form onSubmit={getDeliveryAddress}>
                                        <Col>
                                            <FormControl variant="outlined" color={"warning"}>
                                                <InputLabel htmlFor="outlined-adornment-password">Enter Pin Code</InputLabel>
                                                <OutlinedInput
                                                    color={'warning'}
                                                    value={bodyData?.pincode || ""}
                                                    aria-required={true}
                                                    required={true}
                                                    onChange={handleChangePincode} name="pincode"
                                                    placeholder={'Enter pincode here...'}
                                                    type="number" aria-valuemax={6} aria-valuemin={6}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <Button disabled={btnLoading2} type={'submit'}
                                                                className="bgprimary" variant={'contained'}
                                                            >{btnLoading2 &&
                                                                <CircularProgress size={16}
                                                                    color={"inherit"} />}&nbsp;{btnText}</Button>
                                                        </InputAdornment>
                                                    }
                                                    label="Password"
                                                />
                                            </FormControl>

                                            {/* <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
                                                <TextField size={"small"} value={bodyData.pincode || ""}
                                                           aria-required={true}
                                                           required={true}
                                                           onChange={handleChangePincode} name="pincode"
                                                           placeholder={'Enter pincode here...'}
                                                           type="number" aria-valuemax={6} aria-valuemin={6}/>
                                                <Button disabled={btnLoading2} type={'submit'}
                                                        className="" variant={'contained'}
                                                        color={'warning'}>{btnLoading2 &&
                                                <CircularProgress size={16} color={"inherit"}/>}&nbsp;{btnText}</Button>
                                            </Box> */}
                                         </Col>
                                    </Form>
                                </Row>  


                                {data?.cod && (data?.cod?.error === false ?
                                    <b className={'text-success'}><small>{data?.cod?.message}</small></b> :
                                    <b className={'text-danger'}><small>{data?.cod?.message}</small></b>)}
                                <br />
                                {data?.delivery && (data?.delivery?.error === false ?
                                    <b className={'text-success'}><small>{data?.delivery?.message}</small></b> :
                                    <b className={'text-danger'}><small>{data?.delivery?.message}</small></b>)}
                            </div>
                     
                           
                             {/* specilaity superfast delivery and other starts here */}

                        <div className="d-flex special justify-content-center mb-2">
                            <div className="text-center quality mx-3" >
                            <img src={DeliveryImage} alt="Superfast Delivery" style={{ width: "65px", height: "60px" }} />
                            <p style={{ fontSize: "13px"}}  className=" superfastText fw-bold" >Superfast<br />Delivery</p>
                            </div>
                            <div className="text-center mx-3">

                            <img
                                src={FreeExpertSupport}
                                alt="Superfast Delivery"
                                style={{ width: '65px', height: '60px' }}
                            />
                            <p className=" superfastText fw-bold" style={{ fontSize: '13px' }}>
                                Free Expert<br />Support
                            </p>
                            </div>
                            <div className="text-center mx-3 ">
                            <img src={SecurePayment} alt="Superfast Delivery " style={{ width: "65px", height: "60px" }} />
                                <p style={{ fontSize: "13px"}} className=" superfastText fw-bold">Secure<br />Payment</p>
                            </div>
                        </div>



                             {/* specilaity superfast delivery and other starts here */}





                   {/* add to cart and Buy Now Buttons starts here */}
                            {/* <Row xs={{ cols: 1 }} className=" g-2">


                                <Col className="mt-3">
                                    {isAvailable ? (
                                        authInfo.profile.id ? (
                                            cart === "yes" || inCart === "yes" ?
                                                <MoreButton onClickChange={onNavigate} className={'mx-auto'}>
                                                    <FaShoppingCart />  &nbsp; View Cart </MoreButton> :
                                                <MoreButton disabled={btnLoading} onClickChange={onClick}
                                                    colorChange={colorChange}>
                                                    {btnLoading && <CircularProgress size={16}
                                                        color={"inherit"} />}<FaShoppingCart /> &nbsp; {buttonText}
                                                </MoreButton>

                                        ) : (<MoreButton onClickChange={() => setShowLoginModel(true)}
                                            className={'mx-auto'}><FaShoppingCart />  &nbsp; Add To Cart
                                        </MoreButton>)

                                    ) : (<>
                                        <ProductNotifyMe tokenPart={part?.token} part={part} /> */}
                                        {/*<b className={'text-danger text-center'}>*Notify me when available*</b>*/}
                                        {/*<b className={'text-danger text-center'}>*This product is currently not
                                            available.
                                            Please visit after sometime.*</b>*/}
                                    {/* </>)}

                                </Col>

                                <Col>
                                    {isAvailable ? (
                                        authInfo?.profile?.id ? (
                                            <div onClick={onClickBuyNow} className="buy-button text-center">
                                                {buyNowLoading &&
                                                    <CircularProgress size={16} color={"inherit"} />} &nbsp; &nbsp;
                                                <FaShoppingBasket />  &nbsp; {buttonTextBuy}
                                            </div>) : (
                                            <div onClick={() => setShowLoginModel(true)}
                                                className="buy-button text-center">
                                                <FaShoppingBasket />  &nbsp; {buttonTextBuy}
                                            </div>)
                                    ) : ""}
                                </Col>
                            </Row> */}
                                    {/* add to cart and Buy Now Buttons ends here */}



                                             {/* new style for add to cart and Buy Now Button starts here */}
                
                                             <Row xs={{ cols: 1 }} className="g-2">
                                                <Col className="mt-3">
                                                    {isAvailable ? (
                                                            <div className="d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: "64px",
                                                                display: "inline-flex",
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                                overflow: "hidden"
                                                            }}>
                                                         
                                                              
                                                                {/* Cart Button (Show "Add to Cart" or "View Cart") */}
                                                                <div onClick={cart === "yes" || inCart === "yes" ? onNavigate : onClick} 
                                                                    className="d-flex  align-items-center justify-content-center cartIconBtnM"
                                                                    style={{
                                                                        width: "60px",
                                                                        background: "#f58220",
                                                                        color: "#fff",
                                                                        fontSize: "20px",
                                                                        borderTopLeftRadius: "10px",
                                                                        borderBottomLeftRadius: "10px",
                                                                        height: "93%",
                                                                        marginRight: "-10px", // creates the concave visual overlap
                                                                        borderTopRightRadius:"15px",
                                                                        borderBottomRightRadius:"15px",
                                                                        zIndex: 1,
                                                                        border: "3px solid #fff", 
                                                                        position: "relative"
         
                                                                    }}>
                                                                
                                                                <FaShoppingCart style={{ fontSize: '30px',cursor:"pointer" }} />
  
                                                                {(cart === 'yes' && inCart === 'yes') && (
                                                                    <FaCheck
                                                                    
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '4px',
                                                                            right: '4px',
                                                                            backgroundColor: '#28a745',
                                                                            color: 'white',
                                                                            borderRadius: '50%',
                                                                            fontSize: '12px',
                                                                            padding: '2px',
                                                                            zIndex: 2, // Ensure tick is always on top of cart
                                                                    }}
                                                                    />
                                                                )}
                                                                </div>
                                                                


                                                                {/* Buy Now Button (Always Present) */}
                                                                <div onClick={onClickBuyNow}
                                                                    className="d-flex align-items-center justify-content-center flex-grow-1 buyBtnM"
                                                                    style={{
                                                                        padding: "0 25px",
                                                                        cursor: "pointer",
                                                                        background: "#0dac4c",
                                                                        color: "#fff",
                                                                        fontWeight: "bold",
                                                                        fontSize: "16px",
                                                                        height: "92%",
                                                                        width:"83%",
                                                                        borderTopRightRadius:"10px",
                                                                        borderBottomRightRadius:"10px"
                                                                    }}>
                                                                    {buyNowLoading && <CircularProgress size={16} color="inherit" />} 
                                                                    {buttonTextBuy}
                                                                </div>
                                                                 {/* <div onClick={onClickBuyNow}
                                                                    className="d-flex align-items-center justify-content-center flex-grow-1"
                                                                    style={{ padding: "12px 15px", cursor: "pointer", borderRadius: "0 5px 5px 0", background: "#ff3d00", color: "#fff", fontWeight: "bold" }}> */}
                                                                    {/* {buyNowLoading && <CircularProgress size={16} color="inherit" />}  
                                                                     <FaShoppingBasket className="me-1" />  
                                                                     {buttonTextBuy}
                                                                </div>  */}
                                                            </div>
                                                     
                                                    ) : (
                                                        <ProductNotifyMe tokenPart={part?.token} part={part} />
                                                    )}
                                                </Col>
                                            </Row>

                                    {/* new style for add to cart and Buy Now Button ends here */}
                                   


                            {/* <div className="d-flex text-center">
                                <div className="">
                                    {isAvailable? (
                                        cart === "yes" || inCart === "yes" ?
                                            <MoreButton onClickChange={onNavigate} className={'mx-auto'}>View
                                                Cart</MoreButton> :
                                            <MoreButton onClickChange={onClick}
                                                colorChange={colorChange}>{buttonText}</MoreButton>

                                    ) : (<b className={'text-danger text-center'}>*This product is currently not available.
                                        Please visit after sometime.*</b>))}
                                </div>

                                <div className="">
                                    {isAvailable?
                                        <div onClick={onClickBuyNow} className="buy-button text-center">
                                            {buttonTextBuy}
                                        </div> : "")}
                                </div>
                            </div> */}

                        </div>
                    </Col>
                </Row>
            </div>
           <style>
            {
                `
                    .cartIconBtnM:hover, .buyBtnM:hover {
                        box-shadow: 0 .5em .5em -.4em var(--primary);
                        transform: translateY(-.25em);
                    }

                              @media (max-width: 480px) {
                                    .superfastText {
                                    font-size: 13px !important;
                                    }
                                }

                                 @media (max-width: 1024px) {
                                    .superfastText {
                                    font-size: 13px !important;
                                    }
                                }
                `
            }
           </style>
            
        </div>
        {/* <button onClick={() => setShowLoginModel(true)}>Open Login</button> */}

        <MDBModal open={showLoginModellogin} tabIndex='-1' setOpen={setShowLoginModellogin}>
        <MDBModalDialog size='lg' centered>
          <MDBModalContent>
            <MDBModalBody className="pt-0 ps-0 pe-0 pb-0">
           <LoginModal closeModal={() => setShowLoginModellogin(false)} />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
        </MDBModal>
        </>
    );
}